import { render, staticRenderFns } from "./JobseekerManagement.vue?vue&type=template&id=74d3f1c3&"
import script from "./JobseekerManagement.vue?vue&type=script&lang=js&"
export * from "./JobseekerManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports